export const GA_ORGANIZER_CATEGORY = 'organizer';
